import styled, { css } from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";
import { Checkbox, FlexRow } from "@similarweb/ui-components";
import { Stack } from "@similarweb/ui-components/foundations";

import { ExpandButton } from "app/pages/sales-intelligence/common-components/collapsible-panel";

const FILTER_CARD_WIDE_BREAKPOINT_PX = 480;

export const filterCardContainerSetup = (containerName: string) => css`
    container-type: inline-size;
    container-name: ${containerName};
`;

export const filterCardWideQuery = (containerName: string) =>
    `@container ${containerName} (min-width: ${FILTER_CARD_WIDE_BREAKPOINT_PX}px)`;

export const StyledFiltersPanelExpandButton = styled(ExpandButton)`
    background-color: ${colorsPalettes.carbon[0]};
    border: 1px solid ${colorsPalettes.sky[100]};
`;

export const StyledFilterContentBanner = styled(Stack)`
    gap: 8px;
    align-items: flex-start;
    padding: 8px;

    border-radius: 8px;
    border: 1px solid ${colorsPalettes.bluegrey[300]};
    background: ${colorsPalettes.bluegrey[200]};
`;

export const StyledFilterCheckbox = styled(Checkbox)`
    label {
        ${mixins.setFontVariant("body1")};
    }
`;

export const StyledFilterCheckboxContainer = styled.div`
    display: flex;
    align-items: center;
`;

export const FilterResultContainer = styled(FlexRow)`
    flex-wrap: wrap;
`;
